import { useState } from 'react'
import {
  useMediaQuery,
  Grid,
  makeStyles,
  useTheme,
  Container,
  Link as MuiLink,
} from '@material-ui/core'
import Layout from '../components/common/Layout'
import Positions from '../components/career/Positions'
import ButtonSp from '../components/ui/ButtonSp'
import CarouselSp2 from '../components/ui/CarouselSp2'

import Link from '../components/utility/CustomLink'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

const useStyles = makeStyles((theme) => ({
  page: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& h2': {
      ...theme.homeStyle.title,
    },
    '& h4': {
      ...theme.homeStyle.topic,
    },
  },
  heroImg: {
    background:
      'linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url("/static/img/career/career-header-2.jpg")',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    height: theme.homeStyle.heroImageHeightDesktop,
    color: 'white',
    [theme.breakpoints.down('xs')]: {
      background:
        'linear-gradient(rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.4)), url("/static/img/career/career-header-2.jpg")',
      backgroundSize: 'cover',
      height: theme.homeStyle.heroImageHeightMobile,
      padding: theme.spacing(1),
    },
  },
  heroTitle: {
    ...theme.homeStyle.heroTitle,
  },
  moshi: {
    width: '100%',
  },
  benefitsSection: {
    ...theme.homeStyle.section,
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  benefitBox: {
    padding: theme.spacing(2),
  },
  benefitsGrid: {
    textAlign: 'center',

    '& h4': {
      margin: `0 0 6px 0`,
      color: theme.palette.primary.main,
      fontWeight: 400,
      fontSize: 16,
    },
    '& p': {
      margin: 0,
      fontWeight: 400,
      fontSize: 14,
      color: '#828282',
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: 800,
    },
  },
  benefitIcon: {
    maxWidth: 75,
    maxHeight: 75,
  },
  activitiesSection: {
    ...theme.homeStyle.section,
    backgroundColor: '#fafafa',
  },
  followHr: {
    ...theme.homeStyle.section,
  },
  actImg: {
    width: 300,
    height: 225,
    objectFit: 'cover',
    borderRadius: 10,
    // overflow: 'hidden',
  },
  whoShippop: {
    '& h1': {
      ...theme.homeStyle.title,
      marginBottom: theme.spacing(2),
      textAlign: 'left',
    },
    '& p': {
      ...theme.homeStyle.bodyText,
      color: '#404041',
    },
    [theme.breakpoints.up('sm')]: {
      maxWidth: 1000,
      margin: `${theme.spacing(10)}px ${theme.spacing(1)}px ${theme.spacing(
        4
      )}px ${theme.spacing(1)}px`,
    },
    [theme.breakpoints.down('xs')]: {
      margin: `${theme.spacing(3)}px ${theme.spacing(1)}`,
    },
  },
  carouselWrapper: {
    width: '100%',
    maxWidth: 1200,
    [theme.breakpoints.down('xs')]: {
      maxWidth: 400,
    },
  },
  heroText: {
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      alignItems: 'flex-end',
    },
  },
  textBtn: {
    fontWeight: '400 !important',
    fontSize: '16px !important',
    color: theme.palette.primary.main,
  },
}))

const TextBtn = ({ text, onClick = null, className }) => (
  <MuiLink component="button" onClick={onClick} className={className}>
    {text} {'>'}
  </MuiLink>
)

const CareerPage = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'))
  const isTablet = !isMobile && !isDesktop
  const classes = useStyles()

  const [isExpanded, setExpanded] = useState(false)

  const { t } = useTranslation('career')

  const renderHeroSection = () => (
    <Grid container className={classes.heroImg}>
      <Container>
        <div className={classes.heroText}>
          <h1 className={classes.heroTitle}>
            {t('hero-1')}
            {!isMobile ? <br /> : ' '}
            {t('hero-2')}
          </h1>
        </div>
      </Container>
    </Grid>
  )

  const renderWhoShippop = () => (
    <Grid container className={classes.whoShippop}>
      <Grid item container xs={12} md={6} direction="column" justify="center">
        <img
          src="/static/img/career/moshi-career.jpg"
          alt="สมัครงาน SHIPPOP"
          className={classes.moshi}
        />
      </Grid>
      <Grid item container xs={12} md={6} direction="column" justify="center">
        <div style={{ padding: 20 }}>
          <h1>{t('who-are-we')}</h1>
          <p>{t('who-are-we-desc')}</p>
          <Link href="/about" passHref>
            <TextBtn text={t('about-us')} className={classes.textBtn} />
          </Link>
        </div>
      </Grid>
    </Grid>
  )

  const benefitsData = [
    {
      icon: 'wfh.svg',
      title: t('benefits.wfh.title'),
      desc: t('benefits.wfh.desc'),
    },
    {
      icon: 'performance.svg',
      title: t('benefits.performance.title'),
      desc: t('benefits.performance.desc'),
    },
    {
      icon: 'snack.svg',
      title: t('benefits.snack.title'),
      desc: t('benefits.snack.desc'),
    },
    {
      icon: 'game.svg',
      title: t('benefits.game.title'),
      desc: t('benefits.game.desc'),
    },
    {
      icon: 'learning.svg',
      title: t('benefits.learning.title'),
      desc: t('benefits.learning.desc'),
    },
    {
      icon: 'birthday.svg',
      title: t('benefits.hbd.title'),
      desc: t('benefits.hbd.desc'),
    },
    {
      icon: 'coffee-day.svg',
      title: t('benefits.coffee-day.title'),
      desc: t('benefits.coffee-day.desc'),
    },
    {
      icon: 'outing.svg',
      title: t('benefits.outing.title'),
      desc: t('benefits.outing.desc'),
    },
    {
      icon: 'bonus.svg',
      title: t('benefits.bonus.title'),
      desc: t('benefits.bonus.desc'),
    },
    {
      icon: 'officemate.svg',
      title: t('benefits.office-mate.title'),
      desc: t('benefits.office-mate.desc'),
    },
    {
      icon: 'insurance.svg',
      title: t('benefits.insurance.title'),
      desc: t('benefits.insurance.desc'),
    },
    {
      icon: 'health-care.svg',
      title: t('benefits.health-insurance.title'),
      desc: t('benefits.health-insurance.desc'),
    },
    {
      icon: 'accident-insurance.svg',
      title: t('benefits.accident-insurance.title'),
      desc: t('benefits.accident-insurance.desc'),
    },
    {
      icon: 'notebook.svg',
      title: t('benefits.notebook.title'),
      desc: t('benefits.notebook.desc'),
    },
    {
      icon: 'credit-card.svg',
      title: t('benefits.credit-card.title'),
      desc: t('benefits.credit-card.desc'),
    },
    {
      icon: 'shipping.svg',
      title: t('benefits.shipping.title'),
      desc: t('benefits.shipping.desc'),
    },
    {
      icon: 'relax.svg',
      title: t('benefits.relax.title'),
      desc: t('benefits.relax.desc'),
    },
    {
      icon: 'sport.svg',
      title: t('benefits.sports.title'),
      desc: t('benefits.sports.desc'),
    },
  ]

  const renderBenefitsGrid = () => {
    return (
      <div className={classes.benefitsSection}>
        <Container
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <h2 className={classes.title}>{t('benefits.title')}</h2>
          <Grid container className={classes.benefitsGrid}>
            {benefitsData.map((benefit, index) => {
              if (isMobile && index > 5 && !isExpanded) return null
              return (
                <Grid
                  item
                  container
                  xs={6}
                  sm={3}
                  direction="column"
                  alignItems="center"
                  className={classes.benefitBox}
                  key={benefit.title}
                >
                  <img
                    src={`/static/img/career/benefits/${benefit.icon}`}
                    alt={benefit.title}
                    className={classes.benefitIcon}
                  />
                  <h4>{benefit.title}</h4>
                  <p>{benefit.desc}</p>
                </Grid>
              )
            })}
          </Grid>
          {!isMobile ? null : isExpanded ? (
            <ButtonSp
              variant="outlined"
              fullWidth
              style={{ height: 50, marginTop: 40 }}
              onClick={() => setExpanded(false)}
              key="readless"
            >
              {t('see-less')}
            </ButtonSp>
          ) : (
            <ButtonSp
              variant="outlined"
              fullWidth
              style={{ height: 50, marginTop: 40 }}
              onClick={() => setExpanded(true)}
              key="readmore"
            >
              {t('see-more')}
            </ButtonSp>
          )}
        </Container>
      </div>
    )
  }

  const renderActivitesSection = () => {
    return (
      <div className={classes.activitiesSection}>
        <h2 className={classes.title}>{t('our-activities')}</h2>
        <div className={classes.carouselWrapper}>
          <CarouselSp2
            slidesPerPage={isMobile ? 1 : isDesktop ? 3 : 2}
            showArrows={!isMobile}
            showDots={isMobile}
            denseDots
          >
            {Array.from({ length: 12 }, (_, i) => i + 1).map((n) => (
              <div key={n}>
                <img
                  className={classes.actImg}
                  src={`/static/img/career/activities/activity${n}.jpg`}
                  alt="กิจกรรมของพนักงาน shippop"
                />
              </div>
            ))}
          </CarouselSp2>
        </div>
      </div>
    )
  }

  const renderFollowHR = () => (
    <div className={classes.followHr}>
      <h2 className={classes.title}>{t('job-news')}</h2>
      <Grid container justify='center' spacing={2}>
        <Grid item xs={12} sm={3}>
          <img
            src="/static/img/icons/facebook.svg"
            alt="ติดตามข่าวสารรับสมัครงานผ่าน Facebook"
            width={90}
            height={90}
          />
          <MuiLink
            href="https://www.facebook.com/SHIPPOPCAREER"
            target="_blank"
            rel="noreferrer"
          >
            <p>facebook.com/SHIPPOPCAREER</p>
          </MuiLink>
        </Grid>
        <Grid item xs={12} sm={3}>
          <img
            src="/static/img/icons/line.svg"
            alt="ติดตามข่าวสารรับสมัครงานผ่าน Line"
            width={90}
            height={90}
          />
          <MuiLink
            href="https://line.me/ti/p/a3f6kuDezX"
            target="_blank"
            rel="noreferrer"
          >
            <p>@shippoprecruit {t('have-at')}</p>
          </MuiLink>
        </Grid>
      </Grid>
    </div>
  )

  return (
    <>
      <Layout
        title="สมัครงาน หางาน หาตำแหน่งงาน เข้าร่วมเป็นทีม SHIPPOP"
        keywords="สมัครงาน, ตำแหน่งงาน, สวัสดิการ, ว่างงาน, shippop"
        description="หาคุณกำลังมองหางาน ที่ใช่ มองหาไอเดียใหม่ๆ อยากทำในบริษัท startup ที่มีสวัสดิการมากมาย ลุยงานกันอย่างสนุกสนาน ลองสมัครเข้ามาทำงานกับ SHIPPOP เลย"
      >
        <div className={classes.page}>
          {renderHeroSection()}
          {renderWhoShippop()}
          {renderBenefitsGrid()}
          {renderActivitesSection()}
          <Positions isMobile={isMobile} isTablet={isTablet} />
          {renderFollowHR()}
        </div>
      </Layout>
    </>
  )
}

export const getServerSideProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      'common',
      'header',
      'footer',
      'pdpa',
      'career',
    ])),
  },
})

export default CareerPage
